import Swiper from "swiper";

export default function initializeProduct() {
    // Ініціалізація Swiper
    if (document.querySelector('.product-single__gallery_slider')) {
        let swiper = new Swiper(".product-single__gallery_slider", {
            slidesPerView: 1,
            spaceBetween: 15,
            speed: 1300,
            loop: true,
            freeMode: false,
            pagination: {
                el: '.product-single__gallery_slider-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }

    // Обробка вкладок продукту
    document.querySelectorAll('.product-tab').forEach(function (item) {
        item.addEventListener('click', function () {
            document.querySelector('.product-tab.active').classList.remove('active');
            item.classList.add('active');

            document.querySelector('.block-collapse__accordion__item.active').classList.remove('active');
            document.querySelector('#desc_key_' + item.getAttribute('id')).classList.add('active');
        });
    });

    // Робимо меню .product-tabs "прилипаючим" при скролі
    const productTabs = document.querySelector('.product-tabs');

    if (productTabs) {
        const offsetTop = productTabs.offsetTop - 160;

        console.log('offsetTop', offsetTop);
        window.addEventListener('scroll', () => {
            // console.log('offsetTop', offsetTop);
            console.log('window.scrollY', window.scrollY);
            if (window.scrollY >= offsetTop) {
                productTabs.classList.add('sticky');
            } else {
                productTabs.classList.remove('sticky');
            }
        });
    }
}
